import { TextResourceItem, TextResourceList } from "@/entities";
import { post } from "./httpRequest";
import { LanguageCode } from "@/enums";
import { getTextResources } from "../../tests/entities";

interface ImportObj {
    url: string;
    isModule: boolean;
}

function dynamicImport(item: ImportObj) {
    const rivertyOnboardingModule = document.createElement("script");
    rivertyOnboardingModule.setAttribute("src", item.url);

    if (item.isModule) rivertyOnboardingModule.setAttribute("type", "module");
    else rivertyOnboardingModule.setAttribute("nomodule", "");

    document.head.appendChild(rivertyOnboardingModule);

    return rivertyOnboardingModule;
}

async function getTranslations(sysNameList: string[], countryCode: string | null | undefined, languageCode: LanguageCode, agent: unknown | null = null): Promise<TextResourceList | getTextResources> {
    if (!countryCode) countryCode = "en";

    const response = await post(
        "api/text-resources/list",
        {
            countryCode,
            languageCode,
            sysNameList,
        },
        agent,
    );

    if (agent != null) {
        return { obj: response, list: sysNameList };
    }

    return response;
}

function translation(list: Array<TextResourceItem>, sysName: string, replace: string[] = []): string {
    let value = list.find((x) => x.sysName == sysName)?.value;

    replace.forEach((item: string, index: number) => {
        value = value?.replace(`{${index}}`, item);
    });

    return value ?? "";
}

function getRivertyDomain(): string {
    return "https://www.riverty.com";
}

function isValidMerchantUrl(url: string): boolean {
    try {
        // Handle URLs without protocol by prepending https://
        const urlToValidate = url.includes('://') ? url : `https://${url}`;
        const parsedUrl = new URL(urlToValidate);
        
        // Allow https:// for web URLs and any custom protocol for app deeplinks
        return parsedUrl.protocol === 'https:' || !parsedUrl.protocol.startsWith('http');
    } catch {
        return false;
    }
}

function currency(value: number, currency = "EUR", location = "en-US") {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat(location, {
        style: "currency",
        currency: currency,
    });
    return formatter.format(value);
}

function loading() {
    const progressBar = document.querySelector("#progress-bar") as HTMLDivElement;
    progressBar.style.display = progressBar.style.display == "flex" ? "none" : "flex";
}

function replaceState() {
    window.history.replaceState(null, document.title, location.href);
}

async function checkFetch(url: string) {
    try {
        return (await fetch(url, { method: "HEAD" })).ok;
    } catch (error) {
        return false;
    }
}

function trackMatomoEvent(action: string, message: string, target: string | null = null) {
    window._paq?.push(['trackEvent', target ?? document.title, action, message]);
}

export { ImportObj, dynamicImport, getTranslations, translation, getRivertyDomain, isValidMerchantUrl, currency, loading, replaceState, checkFetch, trackMatomoEvent };
